import React from "react";
import {
  DiaryContextType,
  GridConfigType
} from "../../../../context/DiaryContext";
import {
  addGridConfigStorage,
  GridConfigDataStorageType
} from "../../../../utils/localStorage/gridConfigStorage";

const enum ConfigOptions {
  displayZones = "displayZones",
  displayUnassigned = "displayUnassigned",
  displayNewAndInProgress = "displayNewAndInProgress",
  displayLeft = "displayLeft",
  displayNewCovers = "displayNewCovers",
  displayClosedAreas = "displayClosedAreas",
  highlightOverrunningBookings = "highlightOverrunningBookings",
  highlightOverCapacity = "highlightOverCapacity",
  size = "size"
}
type ConfigButtonListType = {
  key: ConfigOptions;
  label: string;
};
export const configOptions: ConfigButtonListType[] = [
  {
    key: ConfigOptions.displayZones,
    label: "Display Zones"
  },
  {
    key: ConfigOptions.displayUnassigned,
    label: "Display Unassigned"
  },
  {
    key: ConfigOptions.displayNewAndInProgress,
    label: "Display New And In Progress"
  },
  {
    key: ConfigOptions.displayLeft,
    label: "Display Left"
  },
  {
    key: ConfigOptions.displayNewCovers,
    label: "Display New Covers"
  },
  {
    key: ConfigOptions.displayClosedAreas,
    label: "Display Closed Areas"
  },
  {
    key: ConfigOptions.highlightOverrunningBookings,
    label: "Highlight Overrunning Bookings"
  },
  {
    key: ConfigOptions.highlightOverCapacity,
    label: "Highlight Over Capacity"
  }
];

type GridSizeOptionsType = {
  cellHeight: number;
  cellWidth: number;
  areaPanelWidth: number;
};

export const gridSizeOptions: GridSizeOptionsType[] = [
  {
    cellHeight: 24,
    cellWidth: 24,
    areaPanelWidth: 80
  },
  {
    cellHeight: 24,
    cellWidth: 32,
    areaPanelWidth: 80
  },
  {
    cellHeight: 32,
    cellWidth: 32,
    areaPanelWidth: 80
  },
  {
    cellHeight: 32,
    cellWidth: 32,
    areaPanelWidth: 100
  },
  {
    cellHeight: 32,
    cellWidth: 40,
    areaPanelWidth: 128
  },
  {
    cellHeight: 40,
    cellWidth: 40,
    areaPanelWidth: 128
  },
  {
    cellHeight: 40,
    cellWidth: 64,
    areaPanelWidth: 128
  },
  {
    cellHeight: 64,
    cellWidth: 64,
    areaPanelWidth: 128
  },
  {
    cellHeight: 64,
    cellWidth: 96,
    areaPanelWidth: 256
  },
  {
    cellHeight: 96,
    cellWidth: 96,
    areaPanelWidth: 256
  }
];

type UpdateGridConfigType = {
  update: Partial<GridConfigDataStorageType>;
  gridConfig: GridConfigType;
  setDiaryContext: React.Dispatch<
    React.SetStateAction<Partial<DiaryContextType>>
  >;
};
export const updateGridConfig = ({
  update,
  gridConfig,
  setDiaryContext
}: UpdateGridConfigType): void => {
  const applyConfig = getGridConfigForStorage(gridConfig, update);

  const sizeItem = gridSizeOptions[applyConfig.size];

  setDiaryContext({
    gridConfig: {
      ...gridConfig,
      ...applyConfig,
      ...sizeItem
    }
  });

  addGridConfigStorage(applyConfig);
};

const getGridConfigForStorage = (
  gridConfig: GridConfigType,
  update: Partial<GridConfigDataStorageType>
): GridConfigDataStorageType => ({
  displayZones: gridConfig.displayZones,
  displayUnassigned: gridConfig.displayUnassigned,
  displayNewAndInProgress: gridConfig.displayNewAndInProgress,
  displayLeft: gridConfig.displayLeft,
  displayNewCovers: gridConfig.displayNewCovers,
  displayClosedAreas: gridConfig.displayClosedAreas,
  highlightOverrunningBookings: gridConfig.highlightOverrunningBookings,
  highlightOverCapacity: gridConfig.highlightOverCapacity,
  size: gridConfig.size,
  ...update
});
